module.exports = __webpack_public_path__ + "img/1exp.bc07180a.jpg";